module.exports = __webpack_public_path__ + "img/event_industrie_futur.c50e4c6a.png";